import { required, size } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
})

const leaders = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        dialog: false,
        loading: false,
        loadingTbl: false,
        loadingDel: {},
        loadingShow: {},

        id: null,
        leaders: {
            name: '',
            position: '',
            creado_por: '',
            image: null
        },
        listLeaders: [],
        headers: [
            { text: "ID", value: "id", align: 'start', sortable: false },
            { text: "Nombre del lider", value: "nombre", align: 'start', sortable: false },
            { text: "Puesto del lider", value: "puesto", align: 'start', sortable: false },
            { text: "Mostrar en inicio", value: "mostrar_lider", align: 'start', sortable: false },
            { text: "Acciónes", value: "action", align: 'start', sortable: false }
        ],
    }),
    mounted() {
        this.fetchLeaders();
        this.leaders.creado_por = this.creatorId;
    },
    computed: {
        creatorId() {
            return this.$store.state.id;
        },
        imageValidation() {
            return this.id ? '' : 'required';
        }
    },
    methods: {
        reset() {
            this.leaders = {
                name: '',
                position: '',
                image: null
            }
        },
        cancel() {
            this.$refs.datos.reset();
            this.reset();
            this.dialog = false;
        },
        VistaPrevia() {
            this.employees.push({ ...this.employee });
            this.employee.name = '';
            this.employee.position = '';
            this.employee.imageUrl = '';
            this.$refs.form.resetValidation();
        },
        removeEmployee(index) {
            this.employees.splice(index, 1);
        },
        async submitForm(reset) {
            this.loading = true;
            const validTypes = ['image/jpeg', 'image/png', 'image/gif']; // Validación de imagen principal 
            // Restablecer errores previos 
            this.$refs.datos.setErrors({});
            if (!this.id && !this.leaders.image) {
                this.$refs.datos.setErrors({ Imagen: ['Debe seleccionar una imagen'] });
                this.loading = false;
                return;
            }
            if (this.leaders.image && !validTypes.includes(this.leaders.image.type)) {
                this.$refs.datos.setErrors({ Imagen: ['El archivo debe ser una imagen (jpeg, png, gif)'] });
                this.loading = false;
                return;
            }

            const formData = new FormData();
            formData.append('name', this.leaders.name);
            formData.append('position', this.leaders.position);
            formData.append('creado_por', this.leaders.creado_por); // Nuevo campo
            if (this.leaders.image) {
                formData.append('image', this.leaders.image);
            }
            //formData.append('image', this.leaders.image);
            try {
                let response;
                if (this.id) {
                    formData.append('id', this.id);
                    response = await this.$axios.post('updateLeader', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    this.$toast.success('Datos de lider actualizado con exito');
                } else {
                    response = await this.$axios.post('newLeader', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    this.$toast.success('Datos del lider agregados con exito');
                }

                this.$refs.datos.reset();
                reset();
                this.reset();
                this.dialog = false;
                this.fetchLeaders();
            } catch (error) {
                console.error('Error al guardar los eventos:', error);
                this.$toast.error('Hubo un error al guardar los datos');
            } finally {
                this.loading = false;
            }
        },
        async fetchLeaders() {
            this.loadingTbl = true;
            try {
                const response = await this.$axios.get('getLeader');
                this.listLeaders = response.data.all;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            } finally {
                this.loadingTbl = false;
            }
        },
        async deleteLeader(leaderId) {
            this.$set(this.loadingDel, leaderId, true); // Activa el estado de carga solo para la imagen específica
            try {
                const response = await this.$axios.delete('deleteLeader', { data: { leader: leaderId } });
                this.listLeaders = this.listLeaders.filter(f => f.id !== leaderId);
                this.$toast.success('Lider eliminado con éxito');
            } catch (error) {ç
                this.$toast.success('Hubo un error al tratar de eliminar al lider');
                //console.error('Error al eliminar el lider:', error);
            } finally {
                this.$set(this.loadingDel, leaderId, false); // Desactiva el estado de carga después de eliminar la imagen
            }
        },
        async showLeader(leaderId) {
            this.$set(this.loadingShow, leaderId, true); // Inicia el indicador de carga
            try {
                const response = await this.$axios.post('showLeader', { leader: leaderId });
                const newValue = response.data.new_value;
                this.listLeaders = this.listLeaders.map(item => {
                    if (item.id === leaderId) {
                        item.mostrar_lider = newValue;
                    }
                    return item;
                });
                this.$toast.success('Cambios guardados con éxito');
                //this.fetchFiles();
            } catch (error) {
                this.$toast.success('Hubo un error al guardar los cambios');
                //console.error('Error al actualizar el estado de mostrar_lider:', error);
            } finally {
                this.$set(this.loadingShow, leaderId, false); // Detiene el indicador de carga
            }
        },
        editLeader(item) {
            this.id = item.id
            this.leaders = {
                name: item.nombre,
                position: item.puesto
            }
            this.dialog = true
        }
    }
}
export default leaders